import { render, staticRenderFns } from "./OfferBeneficiaryDetails.vue?vue&type=template&id=548dd70e&"
import script from "./OfferBeneficiaryDetails.vue?vue&type=script&lang=js&"
export * from "./OfferBeneficiaryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports